module.exports = __webpack_public_path__ + "img/nrslogovectorallwhitestacked@4x.e3e34061.png";